import React, { useState, createContext, useContext } from "react";

// Create a context for the role
const RoleContext = createContext();

// Provider component
export const RoleProvider = ({ children }) => {
  const [role, setRole] = useState("basic");

  // The value that will be given to the context
  const value = { role, setRole };

  return <RoleContext.Provider value={value}>{children}</RoleContext.Provider>;
};

// Hook to use the role state in any component
export const useRole = () => {
  const context = useContext(RoleContext);
  if (context === undefined) {
    throw new Error("useRole must be used within a RoleProvider");
  }
  return context;
};
